$(document).ready(function() {
    var cfg = window.giftcardConfig || {};
    var minimalAmount  = cfg.minimalAmount  || 0;
    var maximalAmount  = cfg.maximalAmount  || 0;
    var currency       = cfg.currency       || '';
    var hasCustomAmounts = cfg.hasCustomAmounts || false;
    var messageOneLine = cfg.messageOneLine || false;
    $('.balanceButton').on('click', function() {
        $('#selectBalance').hide();
        $('.euro-symbol').removeClass('show-symbol');
    });

    $('#balance_other').on('click', function() {
        $('#selectBalance').show();
        $('.euro-symbol').addClass('show-symbol');
    });
    
    $('#send_date').on('change input', function() {
        if ($(this).val() != '' && $(this).hasClass('inputErr')) {
            $(this).removeClass('inputErr');
        }

        // Reset timepicker
        $('#send_time').val('');

        var sendDate = $(this).val();
        var now = new Date();
        var availableTime = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');
        var day = ("0" + now.getDate()).slice(-2);
        var month = ("0" + (now.getMonth() + 1)).slice(-2);
        var year = now.getFullYear();
        var formattedNow = day + "/" + month + "/" + year;

        if ($('body').hasClass('en')) {
            formattedNow = month + "/" + day + "/" + year;
        }

        // Reset timepicker if date is changed
        if (sendDate !== formattedNow) {
            $('#send_time').timepicker('destroy');

            $('#send_time').timepicker({
                timeFormat: 'HH:mm',
                interval: 30,
                dynamic: false,
                dropdown: true,
                scrollbar: true,
                change: function() {
                    if ($('#send_time').hasClass('inputErr')) {
                        $('#send_time').removeClass('inputErr');
                        $('#time_warning').hide();
                    }
                }
            });
        } else {
            // If the date is today, set the timepicker to available time
            $('#send_time').timepicker('destroy');

            $('#send_time').timepicker({
                timeFormat: 'HH:mm',
                minTime: availableTime,
                interval: 30,
                dynamic: false,
                dropdown: true,
                scrollbar: true,
                change: function() {
                    if ($('#send_time').hasClass('inputErr')) {
                        $('#send_time').removeClass('inputErr');
                        $('#time_warning').hide();
                    }
                }
            });
        }
    });

    $('#send_time').on('change input', function() {
        var sendTime = $(this).val();
        var timeWarning = $('#time_warning');
        
        if (sendTime) {
            timeWarning.hide();
            $(this).removeClass('inputErr');
        }
    });
    
    $('input[data-check], textarea[data-check]').each(function() {
        var elt = $(this);

        if (elt.attr('data-check') === 'no_empty') {
            elt.on('keyup', function() {
                if (elt.val().length > 0) {
                    elt.removeClass('inputErr');
                }
            });
            elt.on('blur', function() {
                if (elt.val().length === 0) {
                    elt.addClass('inputErr');
                }
            });
        }
    });

    function toggleSendTo() {
        var isOwn = $('#sendToOwn').is(':checked');
        $('.sendingToOwn').toggle(isOwn);
        $('.sendingToReceiver, .sendToReceiverBloc').toggle(!isOwn);
    }

    function toggleSendLater() {
        $('.sendLater').toggle($('#sendGiftcardLater').is(':checked'));
    }

    $('input[name="sendTo"]').on('change', toggleSendTo);
    $('input[name="sendGiftcardTime"]').on('change', toggleSendLater);

    toggleSendTo();
    toggleSendLater();

    // Bind once: avoid stacking listeners on each submit click.
    if (hasCustomAmounts) {
        $('#orderGiftCardForm input[type=radio][name=balanceButton]').on('change', function() {
            $('#orderGiftCardForm input[type=radio][name=balanceButton]').next().removeClass('inputErr');
            $('#selectBalance').removeClass('inputErr');
        });

        $('#orderGiftCardForm input[type=number][name=balance]').on('change', function() {
            $('#orderGiftCardForm input[type=radio][name=balanceButton]').next().removeClass('inputErr');
            $(this).removeClass('inputErr');
        });
    }

    $('#js-submitStep2, #addCardToCart').on("click", function(e) {
        var error = false;
        e.preventDefault();

        if(hasCustomAmounts) {
            var amountSelector = $('#orderGiftCardForm input[type=radio][name=balanceButton]:checked');
            
            // If amountSelector is equal to other then amountSelector takes the value of input number
            if (amountSelector == 'other') {
                var amountSelector = $('#orderGiftCardForm input[type=number][name=balance]');
            }
        } else {
            var amountSelector = $('#orderGiftCardForm input[type=number][name=balance]');
        }

        var amountValue = amountSelector.val();
        var maxValue = maximalAmount;
        amountSelector.removeClass('inputErr');
        $(".min_amount_gift").hide();
        $(".max_amount_gift").hide();
        $(".no_amount_gift").hide();
        $(".decimal_amount_gift").hide();

        if (!amountValue || isNaN(amountValue) || parseInt(amountValue) != amountValue) {
            amountSelector.addClass('inputErr');

            if(isNaN(parseInt(amountValue))){
                $(".no_amount_gift").show();
            } else {
                $(".decimal_amount_gift").show();
            }
            error = true;
        }

        if (!error && amountValue < minimalAmount) {
            amountSelector.addClass('inputErr');
            $(".min_amount_gift").show();
            error = true;
        }

        if (maxValue > 0 && amountValue > maxValue) {
            amountSelector.addClass('inputErr');
            $(".max_amount_gift").show();
            error = true;
        }

        var recipientFirstName = $('input[name="r_fname"]');
        var senderSignature = $('input[name="s_sign"]');
        if (messageOneLine) {
            var senderMsgPerso = $('input[name="s_msgPerso"]');
        } else {
            var senderMsgPerso = $('textarea[name="s_msgPerso"]');
        }

        if (hasCustomAmounts) {
            var selectedBalanceInput = $('#orderGiftCardForm input[type=radio][name=balanceButton]:checked');
            var isOtherSelected = selectedBalanceInput.val() == 'other';
            var giftcardBalance = isOtherSelected ? $('#selectBalance').val() : selectedBalanceInput.val();
            $('#selectBalance').val(giftcardBalance);
        } else {
            var giftcardBalance = $("#selectBalance").val();
        }

        var error = false;

        if (recipientFirstName.val() === '') {
            recipientFirstName.addClass('inputErr');
            error = true;
        }

        if (senderSignature.val() === '') {
            senderSignature.addClass('inputErr');
            error = true;
        }

        if ($('#sendToReceiver').is(':checked')) {
            var receiverEmail = $('#reveicer_email');

            if (receiverEmail.val() === '') {
                receiverEmail.addClass('inputErr');
                error = true;
            }
        } else if (!$('#sendToReceiver').is(':checked') && $('#sendGiftcardLater').is(':checked')) {
            $('#sendGiftcardLater').prop('checked', false);
            $('#sendGiftcardNow').prop('checked', true);

            $('.sendLater').hide();
            $('#send_date').removeClass('inputErr');
            $('#send_time').removeClass('inputErr');
        }

        if ($('#sendGiftcardLater').is(':checked')) {
            var sendDate = $('#send_date');
            var sendTime = $('#send_time');
            var timeWarning = $('#time_warning');

            if (sendDate.val() === '') {
                sendDate.addClass('inputErr');
                error = true;
            }

            if (sendTime.val() === '') {
                sendTime.addClass('inputErr');
                timeWarning.show();
                error = true;
            }
        }

        if (giftcardBalance === '' || isNaN(giftcardBalance) || parseInt(giftcardBalance) != giftcardBalance || giftcardBalance < minimalAmount) {
            if (hasCustomAmounts) {
                $('#orderGiftCardForm input[type=radio][name=balanceButton]').next().addClass('inputErr');
            }
            $('#selectBalance').addClass('inputErr');
            error = true;
        }

        if (!error) {

            $('#js-balance').html(giftcardBalance + currency);
            $('#js-name').html(recipientFirstName.val().replace(/</g, "&lt;").replace(/>/g, "&gt;"));
            $('#js-signature').html(senderSignature.val().replace(/</g, "&lt;").replace(/>/g, "&gt;"));
            // "replace" function here is used to include line breaks in the textarea element
            if (senderMsgPerso.val() === '') {
                $('#js-message').parent().hide();
            } else {
                $('#js-message').html(senderMsgPerso.val().replace(/\n\r?/g, '<br />'));
                $('#js-message').parent().show();
            }

            openMultiShad('giftCardRecap');
        }
    });
});
